import * as React from "react";
import {Types}    from "@Common/types";

import "./cat-scroll.scss";

import {ActiveWheel}         from "@Common/react/active-wheel";
import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {HoldRepeatingAction} from "@Common/react/hold-repeating-action";
import {UseState}            from "@Common/react/use-state";

export const rCatScroll = (next, arrowPosition) => cs(
    ["more", (_, next) => UseState({
        initValue: {top: false, bottom: false},
        next,
    })],
    consumeContext("themeScheme"),
    ({more,themeScheme} : {
        more: Types.Common.React.UseState.UseStateNext<{top: boolean, bottom: boolean}>,
        themeScheme,
    }) => {
        let catScroll = null;
        const checkScroll = () => {
            const moreTop : boolean = catScroll.scrollTop > 0;
            const moreBottom : boolean = catScroll.scrollTop < catScroll.scrollHeight - catScroll.clientHeight;

            if (more.value.top !== moreTop || more.value.bottom !== moreBottom) {
                more.onChange({top: moreTop, bottom: moreBottom});
            }
        };
        return next({
            render: (content) => (
                <ActiveWheel
                    className="cat-scroll-43j"
                    onWheel={(e) => e.preventDefault()}
                >
                    {more.value.top && cs(
                        ["hold", (_, next) => <HoldRepeatingAction {...{
                            action: () => catScroll.scrollTop -= 30,
                            next,
                        }} />],
                        ({hold}) => (
                            <div
                                className="top-indicator indicator"
                                style={{
                                    borderBottomColor: themeScheme.xpresso.menuTextColor,
                                    left: arrowPosition
                                }}
                                onMouseDown={hold.start}
                                onMouseUp={hold.stop}
                                xd-qa-type="icon"
                                xd-qa-name="arrow_up"
                                onClick={(e) => e.stopPropagation()}
                            />
                        ),
                    )}
                    {more.value.bottom && cs(
                        ["hold", (_, next) => <HoldRepeatingAction {...{
                            action: () => catScroll.scrollTop += 30,
                            next,
                        }} />],
                        ({hold}) => (
                            <div
                                className="bottom-indicator indicator"
                                style={{
                                    borderTopColor: themeScheme.xpresso.menuTextColor,
                                    left: arrowPosition
                                }}
                                onMouseDown={hold.start}
                                onMouseUp={hold.stop}
                                xd-qa-type="icon"
                                xd-qa-name="arrow_down"
                                onClick={(e) => e.stopPropagation()}
                            />
                        )
                    )}
                    <ActiveWheel
                        _ref={(r) => {
                            if (r) {
                                catScroll = r;
                                checkScroll();
                            }
                        }}
                        className="content"
                        onWheel={(e) => {
                            if (e.deltaY < 0 && catScroll.scrollTop === 0) {
                                e.preventDefault();
                            } else if (e.deltaY > 0 && (catScroll.scrollTop >= catScroll.scrollHeight - catScroll.clientHeight)) {
                                e.preventDefault();
                            }
                            e.stopPropagation();
                        }}
                        onScroll={checkScroll}
                    >
                        {content}
                    </ActiveWheel>
                </ActiveWheel>
            ),
        });
    }
);
